import { useContext, useEffect, useState } from 'react';
import { WorkshiftTypeModel } from '../../models';
import { WorkshiftsAPI } from '../../services/external/APIs';
import { AppContext } from '../context/Provider';

/**
 * Devuelve el tipo de turnos
 * @returns WorkshiftTypeModel[]
 * @returns WorkshiftTypeModel[]
 * @returns booelan
 * @returns (newState: WorkshiftTypeModel[]) => void
 * @returns (newState: booelan) => void
 */
export const useGetWorkshiftsList = () => {
    const [workshiftList, setWorkshiftList] = useState<WorkshiftTypeModel[]>([]);
    const [workshiftListCopy, setWorkshiftListCopy] = useState<WorkshiftTypeModel[]>(
        []
    );
    const [isLoadingData, setIsLoadingData] = useState(true);

    useEffect(() => {
        WorkshiftsAPI.getAllTypes()
            .then((res) => {
                setWorkshiftListCopy(res);
                setWorkshiftList(res);
            })
            .finally(() => {
                setIsLoadingData(false);
            });
    }, []);

    return {
        workshiftList,
        workshiftListCopy,
        isLoadingDataList: isLoadingData,
        setWorkshiftListCopy,
        setWorkshiftList,
        setIsLoadingData,
    };
};
